import util from "@/mixins/util";

export default {
    mixins: [],
    data() {
        return {}
    },
    methods: {
        replaceBr(content) {
            if (util.isEmpty(content)) {
                return '';
            }
            return content.replace(/(\n|\r\n)/g, '<br>');
        },
        replaceHyphen(data){
            if (util.isEmpty(data)) {
                return '-';
            }
            return data
        },
        returnReview(review){
            switch (review) {
                case 1:
                    return "아쉬웠어요" 
                    break;
                case 2:
                    return "괜찮았어요" 
                    break;
                case 3:
                    return "좋았어요" 
                    break;
                default:
                    return "-"
                    break;
            }
        },
        returnRate(review){
            switch (review) {
                case 1:
                    return "만족해요" 
                    break;
                case 2:
                    return "아쉬워요" 
                    break;
                default:
                    return "-"
                    break;
            }
        },
        returnStyle(data){
            switch (data) {
                case 1:
                    return "캐주얼" 
                    break;
                case 2:
                    return "미니멀" 
                    break;
                case 3:
                    return "스트릿" 
                    break;
                case 4:
                    return "오피스룩" 
                    break;
                case 5:
                    return "비즈니스캐주얼" 
                    break;
                case 6:
                    return "테니스" 
                    break;
                case 7:
                    return "골프" 
                    break;
                case 8:
                    return "아메카지" 
                    break;
                case 9:
                    return "원피스" 
                    break;
                default:
                    return "-"
                    break;
            }
        },

        returnGender(gender){
            switch (gender) {
                case 0:
                    return "남자" 
                    break;
                case 1:
                    return "여자" 
                    break;
                default:
                    return "-"
                    break;
            }
        },    

        returnReason(data){          
            if(!util.isEmpty(data)){
                return data
            } else {
                return '-'
            }
        },
      
    }
   
}
